import React from "react";

const NavBar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom sticky-top">
      <div className="container">
        <a href="#home" className="logo">
          Casual <span>Tech</span>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainNav"
          aria-controls="mainNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="mainNav">
          <ul className="navbar-nav ms-auto align-items-lg-center">
            <li className="nav-item">
              <a className="nav-link" href="#home">
                Welcome
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#about">
                About Us
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#services">
                Services
              </a>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#policies"
                id="policiesDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Policies
              </a>
              <ul className="dropdown-menu" aria-labelledby="policiesDropdown">
                <li>
                  <a className="dropdown-item" href="#return-policy">
                    Return Policy
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#refund-policy">
                    Refund Policy
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#privacy-policy">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#disclaimer">
                    Disclaimer
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#contact">
                Contact Us
              </a>
            </li>
            <li className="nav-item ms-2 d-none d-lg-block">
              <a className="btn btn-primary" href="/start">
                Make Website
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;